import React, { Component } from 'react';
import {Link} from 'react-router-dom';
// import pubsub from 'pubsub-js';

import './App.css';


class App extends Component {

  constructor(props){
    super(props);
    this.state = {
      rfidArray:[]
    }
    console.log(this.props.num);//[passing through route]
  }

  
render() {
    return (
      
      <React.Fragment>
      <div className="container-fluid">
        <div className="row App-header">
          <div className="col-sm-11">Warehouse Operations</div>
          <div className="col-sm-1">
            { sessionStorage.getItem('isLoggedIn') ?<a href="/#/logout">Logout</a> :''}
            
          </div>
        </div>
      </div>
        
          
          <div className="container-fluid ">
        
            <div className = "row top-buffer">
              <div className="col-sm-3 col-md-6 col-lg-4">
                {/* <button className = "btn btn-lg btn-block " > */}
                  <Link className = "link btn btn-lg btn-block " role = "button" to = "tagwriter" >Tag Writer</Link>
                  <Link className = "link btn btn-lg btn-block " role = "button" to = "addBooks" >Add Books</Link>

                  <Link className = "link btn btn-lg btn-block " to = "catalogue" >Magazine Catalogue</Link>

                  {/* <Link className = "link btn btn-lg btn-block " to = "mctagWriter" >MC Tag Writer</Link> */}

                  <Link className = "link btn btn-lg btn-block " to = "sort">Sort Books</Link>

                  <Link className = "link btn btn-lg btn-block " to = "closedcards">Receive Closed Cards</Link>
                <br/>
              </div> 

              <div className="col-sm-3 col-md-6 col-lg-4">
                  <Link className = "link btn btn-lg btn-block " to = "sendout">Sending Out</Link>
                    <Link className = "link btn btn-lg btn-block " to = "receive">Receive</Link>
                    <Link className = "link btn btn-lg btn-block " to = "fulfillment">Fulfillment</Link>
                    {/* <Link className = "link btn btn-lg btn-block " to = "mqtt">mqtt</Link> */}

                    <Link className = "link btn btn-lg btn-block " to = "dispatch">Dispatch</Link>
                    <Link className = "link btn btn-lg btn-block " to = "swapSuggestion">Swap Books Suggestion</Link>
                    
              </div>       
          </div>       
        </div>       
    </React.Fragment>

          
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js